import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export interface ICasIdRequirementType {
  description: string;
  enable?: boolean;
  interview?: string;
  label: string;
}

export interface IStudentIdRequirementType {
  allow_alphabetic: boolean;
  description: string;
  enable?: boolean;
  interview?: string;
  label: string;
  length: number;
}

interface IUpdateRegistrationVariables {
  casIdRequirement?: ICasIdRequirementType;
  studentIdRequirement?: IStudentIdRequirementType;
}

interface IRegistrationResponse {
  allow_alphabetic?: boolean;
  description: string;
  enable: boolean;
  interview: string;
  label: string;
  length?: number;
}

const useUpdateRegistration = () => {
  const queryClient = useQueryClient();
  const {
    mutateAsync: updateRegistration,
    data,
    isLoading,
    error,
  } = useMutation<IRegistrationResponse, Error, IUpdateRegistrationVariables>(
    ['updateRegistration'],
    async ({ casIdRequirement, studentIdRequirement }) => {
      const body = {
        casIdRequirement,
        studentIdRequirement,
      };

      const registration = await fetchWithCsrfToken<IRegistrationResponse>(
        `${PrependUrl.ASYNC}/registration/update`,
        'POST',
        body
      );

      return registration;
    },
    {
      onSuccess: (data: IRegistrationResponse) => {
        queryClient.invalidateQueries({
          queryKey: ['getRegistrationDetails', data.interview],
        });
        queryClient.invalidateQueries({
          queryKey: ['getAssessmentStepDetails', data.interview],
        });
      },
    }
  );

  return {
    updateRegistration,
    data,
    isLoading,
    error,
  };
};

export default useUpdateRegistration;
